// Blog: September 2026 achievements launch.
import { defineDocument, link, list, p, section, strong, text, } from '../../schema';
export const blogAchievementsUnlockedDocument = defineDocument({
    id: 'blog:achievements-unlocked',
    kind: 'blog',
    slug: 'achievements-unlocked',
    route: '/blog/achievements-unlocked',
    seo: {
        title: 'Achievements Unlocked',
        description: 'Achievements are here. Collect rewards as you reach new milestones. Every game counts.',
        imageAsset: 'blogAchievements',
        imageAlt: 'A floating purple foil achievement card with a party-popper emblem',
    },
    hero: {
        eyebrow: [text('Airhead Blog')],
        title: [text('Achievements Unlocked')],
        description: [
            text('Achievements are here. Collect rewards as you reach new milestones. Every game counts.'),
        ],
        imageAsset: 'blogAchievements',
        imageAlt: 'A floating purple foil achievement card with a party-popper emblem',
        showDescription: true,
        background: 'blurred-image',
    },
    meta: {
        author: 'Jay',
        publishedAt: new Date('2026-09-30T00:00:00.000Z'),
        tags: ['news', 'features'],
    },
    sections: [
        section({
            id: 'article',
            blocks: [
                p([
                    text('Until today, your 500th game on Airhead Games looked exactly like your first. No banner, no reward, no record of the 499 games before it.'),
                ]),
                p([
                    text('Now Airhead Games has '),
                    link('/discover/features/achievements', 'achievements'),
                    text(", and each milestone you reach comes with a reward. Every game you've hosted since we launched in September 2025 counts, so longtime hosts start with levels already earned."),
                ]),
            ],
            sections: [
                section({
                    id: 'article__run-up-your-stats',
                    title: 'Run Up Your Stats',
                    blocks: [
                        p([
                            text('I love games with something to strive for. I always end up chasing the numbers: levels reached, career stats, season records, or rankings. The feeling of accomplishment keeps me coming back to those titles, and I want people to feel that way about Airhead Games, too.'),
                        ]),
                        p([text('We are launching with four achievements:')]),
                        list({
                            items: [
                                [
                                    strong('Hello, Chat'),
                                    text(': connect your '),
                                    link('/discover/features/twitch', 'Twitch account'),
                                    text('.'),
                                ],
                                [strong('Party Starter'), text(': host many party games.')],
                                [
                                    strong('Mood Swings'),
                                    text(': host a game in every '),
                                    link('/discover/features/user-preferences#content-style', 'content style'),
                                    text('.'),
                                ],
                                [
                                    strong('Full House'),
                                    text(': host games with more and more players.'),
                                ],
                            ],
                        }),
                        p([
                            text('Each one tracks a different kind of goal: a one-time action, a running count, a collection, or a personal best. Some have levels, and you only see the next goal after you reach the current one.'),
                        ]),
                        p([
                            text('Reaching an achievement milestone earns a reward. For the first batch of achievements, that means '),
                            link('/discover/features/loons', 'Loons'),
                            text('. Future achievements will bring other kinds of rewards, like special access or items. Now that the achievement engine is built, I have many ideas for new ones, and game-specific challenges are coming soon.'),
                        ]),
                    ],
                }),
                section({
                    id: 'article__start-collecting',
                    title: 'Start Collecting',
                    blocks: [
                        p([
                            text('Open '),
                            link('/library/achievements', 'Achievements'),
                            text(" in the Library to see your progress. Select the info icon on a card to see the levels you've earned and when. Not signed in yet? You can browse every achievement first, then "),
                            link('/library?dialog=login', 'log in'),
                            text(' to start earning.'),
                        ]),
                    ],
                }),
            ],
        }),
    ],
});
//# sourceMappingURL=achievements-unlocked.js.map